import { MetaData } from 'shared/types/user';

import { dateToFirestoreTimestamp } from './converters/date-to-firestore-timestamp';
import { getUser, getUserRef } from './get-user';
import { updateDocWithTimestamp } from './helpers';

const flattenObject = (
  obj: Record<string, any>,
  prefix = '',
): Record<string, any> => {
  const result: Record<string, any> = {};

  for (const key in obj) {
    const newKey = prefix ? `${prefix}.${key}` : key;

    if (
      typeof obj[key] === 'object' &&
      obj[key] !== null &&
      !Array.isArray(obj[key])
    ) {
      Object.assign(result, flattenObject(obj[key], newKey));
    } else {
      result[newKey] = obj[key];
    }
  }

  return result;
};

export const updateUserMetaData = async (metaData: Partial<MetaData>) => {
  const user = await getUser();

  // without a user, we cannot update anything.
  if (!user) {
    return;
  }

  const userRef = await getUserRef();

  if (!userRef) {
    return;
  }

  const flattenedSettings = flattenObject(
    dateToFirestoreTimestamp(metaData),
    'user_metadata',
  );

  updateDocWithTimestamp(userRef, flattenedSettings);
};
